import { ComponentSize } from '@eleventheye/asui';
import { NFL_TEAMS_TOTAL, TeamNamesByID } from '@shared/constants';
import TeamDonutChart from 'components/teamdonutchart/TeamDonutChart';
import { calculateLengthValue } from 'helpers/ChartHelpers';
import useViewportDimensions from 'hooks/useViewportDimensions';
import React, { useEffect, useState } from 'react';
import { TeamRankInfo } from 'types';

import styles from './Rank.module.scss';

export const DisplayType = {
  HomeTeam: styles.HomeTeam,
  Leader: styles.Leader,
  AwayTeam: styles.AwayTeam,
};

type DonutCircleProps = {
  className?: string;
  rankInfo: TeamRankInfo;
  displayType: 'HomeTeam' | 'Leader' | 'AwayTeam';
  chartBy?: 'Rank' | 'Value';
  donutLabel?: React.ReactNode;
  donutSubLabel?: React.ReactNode;
};

const DonutCircle: React.FC<DonutCircleProps> = ({
  className = '',
  rankInfo,
  displayType,
  chartBy = 'Rank',
  donutLabel,
  donutSubLabel,
}) => {
  const baseCls = `${styles.RankLineTeam} ${styles[TeamNamesByID[parseInt(rankInfo.teamID)]]} ${className} `;
  const { isAppMobile } = useViewportDimensions();
  const [lengthValue, setLengthValue] = useState<string>('0px');

  const chartByRank = (rankInfo: TeamRankInfo) => {
    const percentage = 100 - Math.floor((rankInfo.teamRank * 100) / NFL_TEAMS_TOTAL);
    // in case value is zero, add a small % to be shown
    setLengthValue(`${Math.min(percentage + 3, 100)}`);
  };

  const chartByValue = (rankInfo: TeamRankInfo) => {
    const percentage = (rankInfo.teamValue * 100) / rankInfo.bestTeam!.value;
    setLengthValue(`${Math.min(percentage + 3, 100)}`);
  };

  useEffect(() => {
    if (!rankInfo) return;

    if (chartBy === 'Value' && rankInfo.bestTeam) {
      chartByValue(rankInfo);
    } else if (chartBy === 'Rank') {
      chartByRank(rankInfo);
    } else {
      setLengthValue(calculateLengthValue(rankInfo, chartBy, isAppMobile ? 250 : 280));
    }
  }, [rankInfo, displayType, chartBy]);

  const getDonutSize = () => {
    return displayType === 'Leader' ? '80px' : '130px';
  };

  return (
    <TeamDonutChart
      className={baseCls}
      teamId={parseInt(rankInfo.teamID)}
      donutSize={getDonutSize()}
      size={displayType === 'Leader' ? ComponentSize.Small : ComponentSize.Large}
      value={parseFloat(lengthValue)}
      donutLabel={donutLabel}
      donutSubLabel={donutSubLabel}
      isLeaderChart={displayType === 'Leader'}
    />
  );

  // <span className={`${baseCls} ${graphCls}`} style={getDimensionStyle()}></span>;
};

export default DonutCircle;
